import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Text, Box, VStack, useTheme } from 'native-base';
import SearchResultItem from './SearchResultItem';
import { getFriendlyOrDiscourseUsername } from '../utils/helpers';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { useMessagesDispatch } from '../../context/messages';
import { searchAPI } from '../../context/search';
import { useUserState, useUserDispatch } from '../../context/user';
import { DEBOUNCE_DELAY, SEARCH_TERM_MIN } from '../Constants';
import Select from 'react-select';
import { useOverviewState } from '../../context/overview';
import { dmNotAllowedAlert, checkPreviousMessageData } from '../utils/helpers';
const SearchRecipient = ({
  navigation,
  dmUsers,
  setDMUsers,
  setTopic,
  setPrivateMessageId
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const [term, setTerm] = useState('');
  const [usersResult, setUsersResult] = useState([]);
  const [debouncedValue] = useDebounce(term, DEBOUNCE_DELAY);
  const isInputValid = debouncedValue.length >= SEARCH_TERM_MIN;
  const authState = useAuthState();
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  const messagesDispatch = useMessagesDispatch();
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const overviewState = useOverviewState();
  const userState = useUserState();
  const userDispatch = useUserDispatch();
  const isMultiDMProduct = envState.is_group_dmable_product;
  useEffect(() => {
    if (inputValue.length >= SEARCH_TERM_MIN) {
      handleSearchResult(inputValue);
    }
  }, [inputValue]);
  const handleInputChange = (value, {
    action
  }) => {
    if (action === 'input-change') {
      setInputValue(value);
    }
  };
  const handleSelectionChange = (selected, action) => {
    if (action.action === 'select-option') {
      let newUser = isMultiDMProduct ? action.option : selected;
      // check if user allows DMs
      if (newUser) {
        // first check if this user has opted out from receiving DMs (moderators can still send messages)
        const {
          can_send_private_message_to_user
        } = newUser;
        if (!can_send_private_message_to_user) {
          dmNotAllowedAlert();
        } else {
          let newSelectedUsers = [...(isMultiDMProduct ? dmUsers : []), newUser];
          setDMUsers(newSelectedUsers);
          messagesDispatch({
            type: isMultiDMProduct ? 'ADD_MESSAGE_USER' : 'SET_MESSAGE_USERS',
            payload: newUser
          });
          checkPreviousMessageData({
            authState,
            envState,
            overviewState,
            messagesDispatch,
            userState,
            userDispatch,
            navigation,
            setPrivateMessageId,
            users: newSelectedUsers
          });
        }
        setOptions([]);
      }
    }
    if (action.action === 'remove-value') {
      let removedUser = action.removedValue;
      /* have to use this instead of selected because
       * selected is empty when the component mounts,
       * even if it is initially populated */
      const updatedArr = dmUsers.filter(u => u.username !== removedUser.username);
      setDMUsers(updatedArr);
      messagesDispatch({
        type: 'REMOVE_MESSAGE_USER',
        payload: removedUser
      });
      if (updatedArr.length) {
        checkPreviousMessageData({
          authState,
          envState,
          overviewState,
          messagesDispatch,
          userState,
          userDispatch,
          navigation,
          setPrivateMessageId,
          users: updatedArr
        });
      }
    }
  };
  const handleSearchResult = async inputValue => {
    try {
      let data = [];
      const response = await searchAPI.searchUser(envState.base_url, authState.api_key, inputValue || debouncedValue, envState.product);
      if (response && response.users) {
        data = response.users;

        // remove self from list
        data = data.filter(user => user.username !== authUserName);

        // no moderators allowed
        data = data.filter(user => !user.moderator);
      }
      const newOptions = data.map(item => ({
        ...item,
        label: item.name,
        value: item.id
      }));
      setOptions(newOptions);
      return data;
    } catch (err) {
      console.log('Error while searching for recipients');
      return [];
    }
  };
  const resetDMUsers = () => {
    messagesDispatch({
      type: 'SET_MESSAGE_USERS',
      payload: []
    });
    setDMUsers([]);
  };
  const renderItem = user => {
    if (user.username && user.username !== authUserName) {
      return /*#__PURE__*/React.createElement(SearchResultItem, {
        user: user,
        key: getFriendlyOrDiscourseUsername(user, 'friendly') + getFriendlyOrDiscourseUsername(user, 'discourse'),
        navigation: navigation
      });
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    alignSelf: 'center',
    fontSize: 'md',
    fontWeight: 'bold'
  }, `Search Member${isMultiDMProduct ? '' : ' by Clicking in The Box Below'}`), /*#__PURE__*/React.createElement(Select, {
    menuPortalTarget: document.body,
    styles: {
      menuPortal: provided => ({
        ...provided,
        zIndex: 100
      }),
      width: '100%',
      container: provided => ({
        ...provided,
        'min-width': '25%'
      })
    },
    components: {
      ...(!isMultiDMProduct && {
        DropdownIndicator: () => null
      })
    },
    isMulti: isMultiDMProduct,
    value: dmUsers,
    options: options,
    onInputChange: handleInputChange,
    onChange: handleSelectionChange,
    onMenuOpen: !isMultiDMProduct && resetDMUsers // onFocus isn't enough
    ,
    formatOptionLabel: renderItem
  }), /*#__PURE__*/React.createElement(Box, {
    w: '100%',
    h: '100%',
    mt: 4
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 2
  }, inputValue.length > 0 && inputValue.length < SEARCH_TERM_MIN && /*#__PURE__*/React.createElement(Box, {
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.searchRecipient.message,
    my: 0
  }, "Please enter at least 3 characters")))));
};
export default SearchRecipient;
//# sourceMappingURL=SearchRecipient.js.map